module.exports = __webpack_public_path__ + "img/03_bohle.0e58c2c5.jpeg";